import {Component, Input} from "@angular/core";
import {Customer} from "../../../../objects/customers/customer";
import {CustomerModalComponent} from "../modal/customerModal.component";
import { ESCustomer } from "../../../../objects/customers/es-customer";
/**
 * Created by alex.y on 9/7/2017.
 */

@Component({
    selector: 'customer-item',
    templateUrl: 'customerItem.component.html',
    moduleId: module.id.toString()
})
export class CustomerItemComponent {

    @Input()
    public customer: ESCustomer;

    public string = String;

    @Input()
    public customerModal: CustomerModalComponent;

}


// WEBPACK FOOTER //
// ./app/components/Managment/customerManagement/customerItem/customerItem.component.ts